import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { AuthService } from './auth.service';

export const RETURN_URL_KEY = 'liciya.return_url';

/**
 * Protege las rutas privadas. Guarda el destino solicitado para volver a él
 * después del login, en vez de dejar al usuario en la portada.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const deny = () => {
    if (typeof sessionStorage !== 'undefined' && state.url && state.url !== '/') {
      sessionStorage.setItem(RETURN_URL_KEY, state.url);
    }
    return router.createUrlTree(['/login']);
  };

  if (!auth.isLoading()) {
    return auth.isAuthenticated() ? true : deny();
  }

  // La sesión aún se está resolviendo: esperar en vez de rechazar.
  return toObservable(auth.isLoading).pipe(
    filter((loading) => !loading),
    take(1),
    map(() => (auth.isAuthenticated() ? true : deny())),
  );
};
